import { FC } from 'react';
import styles from './BtnDownload.module.scss';

interface IBtnDownload {
  externalId: string;
  name?: string;
  lfrom?: string;
}

const BtnDownload: FC<IBtnDownload> = ({ externalId, name, lfrom }) => {
  return (
    <a className={styles.btn} target="_blank" href={`https://www.litres.ru/pages/biblio_book/?art=${externalId}${lfrom ? `&lfrom=${lfrom}` : ``}`}>
      {name ? name : 'Купить и скачать'}
    </a>
  );
};

export default BtnDownload;
